export default {
    modalShowImageVariations: {
        imageAi: 'Billed AI',
        regenerateImage: 'Generer nyt indhold',
        description: 'Beskrivelse',
        style: 'Stil',
        saveToLibrary: 'Gem til biblioteket',
        continue: 'Fortsæt',
        cancel: 'Annuller',
        select: 'Vælg',
        copy: 'Kopiér',
        selectedImage: 'Udvalgt billede',
        saved: 'Gemt',
        variations: 'Variationer',
    },
};
